import { render, staticRenderFns } from "./OrcamentoRateio.vue?vue&type=template&id=53ed2228&lang=html&"
import script from "./OrcamentoRateio.vue?vue&type=script&lang=js&"
export * from "./OrcamentoRateio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports